/* eslint-disable no-console */
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import { DealerConsoleAction } from '../models/communication/baccarat-enums.model';
import { DealerService } from '../services/dealer.service';

@Component({
    selector: 'app-shoe-change',
    standalone: true,
    imports: [CommonModule, MatButton, MatSnackBarModule],
    templateUrl: './shoe-change.component.html',
    styleUrl: './shoe-change.component.scss'
})
export class ShoeChangeComponent {
    constructor(
        private readonly dealerService: DealerService,
        private readonly snackBar: MatSnackBar
    ) {}

    async onShoeChangedClick(button: MatButton): Promise<void> {
        try {
            // eslint-disable-next-line no-param-reassign
            button.disabled = true;
            await this.dealerService.sendDealerActionRequest(DealerConsoleAction.ShoeChanged);
        } catch (error) {
            // eslint-disable-next-line no-param-reassign
            button.disabled = false;
            console.error(error);
            this.snackBar.open('Action failed', 'Close');
        }
    }
}
